import {Injectable} from "@angular/core";

@Injectable()
export class CountryCodesService {
  codes = [
    {
      "countryCode": "US",
      "name": "USA",
      "callingCode": "+1"
    },
    {
      "countryCode": "AR",
      "name": "Argentina",
      "callingCode": "+54"
    },
    {
      "countryCode": "AU",
      "name": "Australien",
      "callingCode": "+61"
    },
    {
      "countryCode": "AT",
      "name": "Østrig",
      "callingCode": "+43"
    },
    {
      "countryCode": "BH",
      "name": "Bahrain",
      "callingCode": "+973"
    },
    {
      "countryCode": "BE",
      "name": "Belgien",
      "callingCode": "+32"
    },
    {
      "countryCode": "BR",
      "name": "Brasilien",
      "callingCode": "+55"
    },
    {
      "countryCode": "BG",
      "name": "Bulgarien",
      "callingCode": "+359"
    },
    {
      "countryCode": "CA",
      "name": "Canada",
      "callingCode": "+1"
    },
    {
      "countryCode": "CL",
      "name": "Chile",
      "callingCode": "+56"
    },
    {
      "countryCode": "CN",
      "name": "Kina",
      "callingCode": "+86"
    },
    {
      "countryCode": "CO",
      "name": "Colombia",
      "callingCode": "+57"
    },
    {
      "countryCode": "HR",
      "name": "Kroatien",
      "callingCode": "+385"
    },
    {
      "countryCode": "CU",
      "name": "Cuba",
      "callingCode": "+53"
    },
    {
      "countryCode": "CY",
      "name": "Cypern",
      "callingCode": "+357"
    },
    {
      "countryCode": "CZ",
      "name": "Tjekkiet",
      "callingCode": "+420"
    },
    {
      "countryCode": "DK",
      "name": "Danmark",
      "callingCode": "+45"
    },
    {
      "countryCode": "DO",
      "name": "Dominikanske Republik",
      "callingCode": "+1"
    },
    {
      "countryCode": "SV",
      "name": "El Salvador",
      "callingCode": "+503"
    },
    {
      "countryCode": "EE",
      "name": "Estland",
      "callingCode": "+372"
    },
    {
      "countryCode": "FI",
      "name": "Finland",
      "callingCode": "+358"
    },
    {
      "countryCode": "FR",
      "name": "Frankrig",
      "callingCode": "+33"
    },
    {
      "countryCode": "GE",
      "name": "Georgien",
      "callingCode": "+995"
    },
    {
      "countryCode": "DE",
      "name": "Tyskland",
      "callingCode": "+49"
    },
    {
      "countryCode": "GH",
      "name": "Ghana",
      "callingCode": "+233"
    },
    {
      "countryCode": "GR",
      "name": "Grækenland",
      "callingCode": "+30"
    },
    {
      "countryCode": "HK",
      "name": "Hong Kong",
      "callingCode": "+852"
    },
    {
      "countryCode": "HU",
      "name": "Ungarn",
      "callingCode": "+36"
    },
    {
      "countryCode": "IN",
      "name": "Indien",
      "callingCode": "+91"
    },
    {
      "countryCode": "ID",
      "name": "Indonesien",
      "callingCode": "+62"
    },
    {
      "countryCode": "IE",
      "name": "Irland",
      "callingCode": "+353"
    },
    {
      "countryCode": "IL",
      "name": "Israel",
      "callingCode": "+972"
    },
    {
      "countryCode": "IT",
      "name": "Italien",
      "callingCode": "+39"
    },

    {
      "countryCode": "JP",
      "name": "Japan",
      "callingCode": "+81"
    },
    {
      "countryCode": "LV",
      "name": "Letland",
      "callingCode": "+371"
    },
    {
      "countryCode": "LT",
      "name": "Litauen",
      "callingCode": "+370"
    },
    {
      "countryCode": "LU",
      "name": "Luxembourg",
      "callingCode": "+352"
    },
    {
      "countryCode": "MY",
      "name": "Malaysia",
      "callingCode": "+60"
    },
    {
      "countryCode": "MT",
      "name": "Malta",
      "callingCode": "+356"
    },
    {
      "countryCode": "MX",
      "name": "Mexico",
      "callingCode": "+52"
    },
    {
      "countryCode": "NL",
      "name": "Holland",
      "callingCode": "+31"
    },
    {
      "countryCode": "NZ",
      "name": "New Zealand",
      "callingCode": "+64"
    },
    {
      "countryCode": "NO",
      "name": "Norge",
      "callingCode": "+47"
    },
    {
      "countryCode": "PK",
      "name": "Pakistan",
      "callingCode": "+92"
    },
    {
      "countryCode": "PA",
      "name": "Panama",
      "callingCode": "+507"
    },
    {
      "countryCode": "PE",
      "name": "Peru",
      "callingCode": "+51"
    },
    {
      "countryCode": "PH",
      "name": "Filippinerne",
      "callingCode": "+63"
    },
    {
      "countryCode": "PL",
      "name": "Polen",
      "callingCode": "+48"
    },
    {
      "countryCode": "PT",
      "name": "Portugal",
      "callingCode": "+351"
    },
    {
      "countryCode": "PR",
      "name": "Puerto Rico",
      "callingCode": "+1"
    },

    {
      "countryCode": "RO",
      "name": "Rumænien",
      "callingCode": "+40"
    },
    {
      "countryCode": "RU",
      "name": "Rusland",
      "callingCode": "+7"
    },
    {
      "countryCode": "SA",
      "name": "Saudi Arabien",
      "callingCode": "+966"
    },
    {
      "countryCode": "SG",
      "name": "Singapore",
      "callingCode": "+65"
    },
    {
      "countryCode": "SK",
      "name": "Slovakiet",
      "callingCode": "+421"
    },
    {
      "countryCode": "SI",
      "name": "Slovenien",
      "callingCode": "+386"
    },
    {
      "countryCode": "ZA",
      "name": "Sydafrika",
      "callingCode": "+27"
    },
    {
      "countryCode": "KR",
      "name": "Sydkorea",
      "callingCode": "+82"
    },
    {
      "countryCode": "ES",
      "name": "Spanien",
      "callingCode": "+34"
    },
    {
      "countryCode": "SE",
      "name": "Sverige",
      "callingCode": "+46"
    },
    {
      "countryCode": "CH",
      "name": "Schweiz",
      "callingCode": "+41"
    },
    {
      "countryCode": "TW",
      "name": "Taiwan, Province of China",
      "callingCode": "+886"
    },
    {
      "countryCode": "TH",
      "name": "Thailand",
      "callingCode": "+66"
    },
    {
      "countryCode": "TR",
      "name": "Tyrkiet",
      "callingCode": "+90"
    },
    {
      "countryCode": "AE",
      "name": "Forenede Arabiske Emirater",
      "callingCode": "+971"
    },
    {
      "countryCode": "GB",
      "name": "Det Forenede Kongerige",
      "callingCode": "+44"
    },
    {
      "countryCode": "VN",
      "name": "Vietnam",
      "callingCode": "+84"
    }
  ];
}



// WEBPACK FOOTER //
// ./src/pages/shared/country-codes.service.ts